import { useTradeWasteContext } from "../../tradeWasteContext";


export default function ShortTermWasteDisposal() {
  const [tradeWasteContext] = useTradeWasteContext();

  return (
    <p>
      You must apply for approval for a one-off discharge if your business
      needs to discharge waste to the wastewater system due to unusual or
      non-routine circumstances. A one-off discharge may be a single discharge
      event or several related events conducted over a period of time,
      typically up to 6 months. A one-off discharge may also be required for
      events such as construction site dewatering, industrial process failure,
      site redemption or adhoc product testing. For more information, go to{" "}
      <a href={tradeWasteContext.moreInformationUrl}>
        Requirements for one-off discharge of trade waste
      </a>{" "}
      page.
    </p>
  );
}
